export default __webpack_public_path__ + "static/media/image 12.cd544d59.png";